// The last way someone looked at a page (albums or stream, how it's grouped), kept on this device only.
export function remembered<T extends string>(key: string, options: readonly T[], fallback: T): T {
  try {
    const value = localStorage.getItem(key)
    return options.includes(value as T) ? (value as T) : fallback
  } catch {
    return fallback
  }
}

export function remember(key: string, value: string) {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Private windows can refuse; the choice just isn't kept.
  }
}
